import React, { useState } from 'react';
import './StockMarketPlace.css';
import {Typography} from 'antd';
import { FaSearch } from 'react-icons/fa';
import { useGetMoversQuery } from '../../../services/BBFinanceAPI';
import { useDispatch } from 'react-redux';
import { getQueriedStocks} from '../../../redux/actions/stockActions';
import StockCard from './StockCard';
import LinearProgress from '../../utils/LinearProgressBar';


const {Title} = Typography;

const StockMarketPlace = () => {
    const {data , isFetching} = useGetMoversQuery();
    const dispatch = useDispatch();
    const [stocks, setStocks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    
    const active = data?.active;
    const [query, setQuery] = useState("");
    const tableOfActive = active?.map((active, i) => ({
        key: i + 1,
        name: active.name,
        ticker: active.tickerName,
        prevclose: active.last,
        change: active.netChange,
        changepercentage: active.pctChange,
        volume: active.volume,
        dayhigh: active.dayHigh,
        daylow: active.dayLow,
        symbol: active.symbol,
    }));

    // Handler for fetching the particular stock
    const getStock = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const data = {
            query: query,
            region: "IN"
        }
        const response = await dispatch(getQueriedStocks(data));
        setStocks(response.data.quote)
        setIsLoading(false);
        setQuery("")
    }


    // Stock Marketplace UI
    return (
    <div className='container my-4 pt-3 px-5'>
        <Title level={3} className="text-center my-2">Stock Market Place</Title>
        <div className='w-75 mx-auto my-4'>
            <form className='form' onSubmit={getStock}>
                <div className='form-group search-bar'>
                    <input  type="text" 
                            name="query" 
                            className="form-control" 
                            id="query"
                            placeholder="Search Stock for your portfolio"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                    />
                    <button className="btn btn-danger btn-sm mx-1" type="submit">
                        <FaSearch />
                    </button>
                </div>
            </form>
        </div>

        <div className="w-75 mx-auto my-1">
        {
                    success ? 
                    (
                         <div className="alert alert-success alert-dismissible fade show" role="alert">
                            {success}
                            <button type="button"  onClick = {() => setSuccess("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    ) : 
                    <></>
                }
                 {
                    error ? 
                    (
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {error}
                        <button type="button" onClick = {() => setError("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close">

                        </button>
                    </div>
                    ) : 
                    <></>
                }
        </div>

        <div className='w-100 mx-auto'>
            {
                isFetching || isLoading
                ? (
                    <div className='w-75 mx-auto my-4 text-center'>
                        <LinearProgress color="danger"/>
                    </div>
                )
                : (
                   <div className='d-flex flex-wrap gap-5 my-5 p-3'>
                       {
                           stocks.length
                           ? ( 
                              stocks?.map((stock) => <StockCard 
                                                        name={stock.tinyName} 
                                                        exchange={stock.exchange} 
                                                        currency={stock.currency} 
                                                        ticker={stock.ticker} 
                                                        key={stock.symbol}
                                                    />)
                            )
                           : (
                               tableOfActive?.map((stock) => <StockCard 
                                                              name={stock.name} 
                                                              change={stock.change} 
                                                              prevClose={stock.prevclose} 
                                                              changePercent={stock.changepercentage} 
                                                              ticker={stock.ticker}
                                                              key={stock.symbol}
                                                              />)
                            )
                       }
                   </div>                
                )
            }
        </div>
     </div>
    )
}

export default StockMarketPlace
